export default function updateDynamicEnum(params,callback){
    params["lang"] = this.dataGet("conf/language");
    this.rest.post("updateDynamicEnumList",params,returnData => {
        callback(returnData);
    })
}